export const SongsData = [
  {
    songName: "Prigida - Pillow Thoughts",
    author: "Marco Baldessari",
    src: "https://open.spotify.com/track/2Hp3OqegIMtyAMH9UXlG6U?si=fd0c03a0682c474f",
    related: [
      {
        artist: "Prigida",
        song: "Pillow Thoughts",
        link: "https://open.spotify.com/track/2Hp3OqegIMtyAMH9UXlG6U?si=fd0c03a0682c474f",
      },
    ],
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: [
      "Gun xx xx xx xx xx xx Gun xx Gun xx xx xx xx xx xx",
      "Gun xx xx xx xx xx xx Dun xx Dun Gun xx xx xx xx Dun",
    ],
  },

  {
    songName: "118",
    author: "Marco Baldessari",
    src: "",
    related: [],
    timeSignature: "4/4",
    feel: "Reggaeton",
    bpm: "90",
    song: [
      "Gun dos gos Ta Gun dos Pa dos Gun dos gos Dun Gun dos Pa Ta",
      "Gun Ta gos dos Gun dos Pa dos Gun dos gos Ta Gun dos gos Dun",
    ],
  },
  {
    songName: "Don't Go",
    author: "Marco Baldessari",
    src: "https://open.spotify.com/track/6IMizBxvWe908mqf9rJlW0?si=b36718f24071433a",
    related: [
      {
        artist: "sloh rou, ron quixote",
        song: "Don't Go",
        link: "https://open.spotify.com/track/6IMizBxvWe908mqf9rJlW0?si=b36718f24071433a",
      },
    ],
    timeSignature: "4/4",
    feel: "Lo-fi",
    bpm: "90",
    song: [
      "Gun xx Gun xx Pa xx xx xx xx xx Gun xx Pa xx xx xx",
      "Gun xx Gun xx Pa xx xx xx xx xx Gun xx Pa xx xx xx",
      "Gun xx xx xx Pa xx Gun xx xx xx Gun xx Pa xx xx xx",
      "Gun xx Gun xx Pa xx xx xx xx xx xx xx Pa xx xx xx",
    ],
  },

  {
    songName: "Stand by me",
    author: "Marco Baldessari",
    src: "https://youtu.be/4X30VFrflD8?t=79",
    related: [
      {
        artist: "Ben E. King",
        song: "Stand By Me",
        link: "https://youtu.be/z5i9vT8wGY8?t=8",
      },
    ],
    timeSignature: "4/4",
    feel: "Pop/rock",
    bpm: "118",
    song: ["Gun dos gos dos Pa dos Gun dos gos dos Gun dos Pa dos gos Dun"],
  },
  {
    songName: "Il Pescatore",
    author: "Marco Baldessari",
    src: "https://youtu.be/4X30VFrflD8?t=79",
    related: [
      {
        artist: "Fabrizio De André",
        song: "Il Pescatore",
        link: "https://www.youtube.com/watch?v=X_kuqsezS24",
      },
    ],
    timeSignature: "4/4",
    feel: "Pop/rock",
    bpm: "120",
    song: ["Gun dos Gun dos Pa dos Gun Ta gos Ta Gun dos Pa dos gos Ta"],
  },

  {
    songName: "Knocking on heaven's door",
    author: "Marco Baldessari",
    src: "https://youtu.be/4X30VFrflD8?t=1",
    related: [
      {
        artist: "Guns N' Roses",
        song: "Knocking on heaven's door",
        link: "https://www.youtube.com/watch?v=f8OHybVhQwc",
      },
    ],
    timeSignature: "4/4",
    feel: "Rock",
    bpm: "66",
    song: ["Gun dos gos dos Pa dos gos Dun Gun dos Gun dos Pa dos gos Ta"],
  },

  {
    songName: "Space jazz",
    author: "Marco Baldessari",
    src: "https://open.spotify.com/track/5JngOFWX3RuNDAhxbofBht?si=72751f72ef2843b8",
    timeSignature: "4/4",
    feel: "Lo-fi",
    bpm: "60",
    song: [
      "Gun xx xx xx Pa xx xx xx xx Dun Gun xx Pa xx xx xx",
      "Gun xx xx xx Pa xx xx Dun xx xx xx xx Pa xx xx Dun",
      "Gun xx xx xx Pa xx xx xx xx Dun Gun xx Pa xx xx xx",
      "Gun xx xx xx Pa xx xx Dun xx xx xx xx Pa xx Gun xx",
    ],
  },

  {
    songName: "Ballad 6/8 (needs swing)", // Needs swing!
    author: "Marco Baldessari",
    src: "https://youtu.be/eMHVExQTi7U?t=239",
    related: [
      {
        artist: "Alicia Keys",
        song: "If I Ain't Got You",
        link: "https://www.youtube.com/watch?v=Ju8Hr50Ckwk",
      },
      {
        artist: "Aretha Franklin",
        song: "A Natural Woman",
        link: "https://www.youtube.com/watch?v=8jCFzreP1ng",
      },
    ],
    timeSignature: "6/8",
    feel: "Ballad",
    bpm: "60",
    song: [
      "Gun xx xx xx xx Dun Pa xx xx xx Gun xx Gun xx xx xx xx Dun Pa xx xx xx xx xx",
    ],
  },

  {
    songName: "Dem bow",
    author: "Marco Baldessari",
    src: "https://youtu.be/eMHVExQTi7U?t=187",
    related: [
      {
        artist: "Shabba Ranks",
        song: "Dem Bow",
        link: "https://www.youtube.com/watch?v=VQqwea8ZSbk",
      },
    ],
    timeSignature: "4/4",
    feel: "Reggaeton",
    bpm: "90",
    song: [
      "Gun dos gos Ta Gun dos Pa dos Gun dos gos Ta Gun dos Pa dos",
      "Gun dos gos Ta Gun dos Pa dos Gun dos gos Ta Gun Ta Pa Ta",
    ],
  },

  {
    songName: "Bo Diddley Beat",
    author: "Marco Baldessari",
    src: "https://youtu.be/eMHVExQTi7U?t=79",
    related: "https://www.youtube.com/watch?v=bixuI_GV5I0",
    timeSignature: "4/4",
    feel: "Rock",
    bpm: "90",
    song: ["Gun dos Gun Dun gos Dun Pa dos gos Dun Gun dos Gun dos Pa dos"],
  },

  {
    songName: "Train beat",
    author: "Marco Baldessari",
    src: "https://youtu.be/eMHVExQTi7U?t=38",
    related: "https://www.youtube.com/watch?v=CnI_LuCJ4Ek",
    timeSignature: "4/4",
    feel: "Country",
    bpm: "130",
    song: [
      "Gun xx Pa xx Gun Ta Pa xx Gun xx Pa xx Gun Ta Pa xx",
      "Gun xx Pa xx Gun Ta Pa xx Gun xx Pa xx Gun Ta Pa Ta",
    ],
  },

  {
    songName: "Advanced rock",
    author: "Marco Baldessari",
    src: "https://www.youtube.com/watch?v=MvzRvF5wGfY",
    timeSignature: "4/4",
    feel: "Rock",
    bpm: "110",
    song: [
      "Gun dos Gun Dun gos Dun Pa dos gos dos Gun Dun Pa Dun gos dos",
      "Gun dos Gun Dun gos Dun Pa dos gos dos Gun Dun Pa Ta gos dos",
    ],
  },

  {
    songName: "Cool one",
    author: "Marco Baldessari",
    src: "https://youtu.be/bJkNqzoxBhE?t=408",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos Gun Ta gos Dun gos dos Gun Ta gos dos"],
  },

  {
    songName: "More bass",
    author: "Marco Baldessari",
    src: "https://youtu.be/bJkNqzoxBhE?t=339",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos Gun Ta gos Dun Gun dos Gun Ta gos dos"],
  },

  {
    songName: "Double snare",
    author: "Marco Baldessari",
    src: "https://youtu.be/bJkNqzoxBhE?t=271",
    timeSignature: "3/4",
    related: [
      "https://www.youtube.com/watch?v=O8hqGu-leFc",
      "https://www.youtube.com/watch?v=6yCIDkFI7ew",
      "https://www.youtube.com/watch?v=0vo23H9J8o8",
    ],
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos Gun Ta gos Ta Gun dos Gun Ta gos dos"],
  },
  {
    songName: "Adding bass",
    author: "Marco Baldessari",
    src: "www.https://youtu.be/bJkNqzoxBhE?t=203",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos Gun Ta gos dos Gun dos Gun Ta gos dos"],
  },
  {
    songName: "Basic shuffle",
    author: "Marco Baldessari",
    src: "https://youtu.be/bJkNqzoxBhE?t=141",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos gos Ta gos dos Gun dos gos Ta gos dos"],
  },
  {
    songName: "Blues 1",
    author: "Marco Baldessari",
    src: "Marco Baldessari",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "60",
    song: [
      "Gun xx gos Ta xx dos Gun xx gos Ta xx dos",
      "gos xx gos Ta xx dos Gun xx gos Dun xx Dun",
      "Gun xx gos Ta xx dos Gun xx gos Ta xx Ta",
      "Gun xx gos Ta xx dos Gun Ta gos Ta xx dos",
    ],
  },

  {
    songName: "117",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Drum-n-bass",
    bpm: "160",
    song: ["Gun dos gos dos Pa dos gos Dun gos Dun Gun Dun Pa dos gos dos"],
  },

  {
    songName: "Late Thoughts",
    src: "https://open.spotify.com/track/3VWWqRer3hLUgKI1H6QKwq?si=5d23fe477c104d23",
    author: "Marco Baldessari",
    related: [
      {
        artist: "Midnight Sleep",
        song: "Late Thoughts",
        link: "https://open.spotify.com/track/3VWWqRer3hLUgKI1H6QKwq?si=5d23fe477c104d23",
      },
    ],
    timeSignature: "4/4",
    feel: "Lo-fi",
    bpm: "60",
    song: [
      "Gun dos gos dos Pa dos gos dos gos dos Gun dos Pa dos gos dos",
      "gos dos gos dos Pa dos Gun dos gos dos gos dos Pa dos Gun dos",
    ],
  },
  {
    songName: "115",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun Dun xx Dun Pa Dun xx Dun xx Dun Gun Ta Gun Dun Pa Dun"],
  },
  {
    songName: "114",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun xx Pa xx Gun xx Pa xx Gun xx Pa Ta xx Ta Pa xx"],
  },
  {
    songName: "lo-fi 3",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Lo-fi",
    bpm: "60",
    song: [
      "Gun xx Gun xx gos xx xx xx xx xx xx xx gos xx xx xx",
      "Gun xx Gun xx gos xx xx xx xx xx xx xx gos xx xx Dun",
      "Gun xx xx xx gos xx xx xx xx xx xx xx gos xx xx xx",
      "Gun xx Gun xx gos xx xx xx Gun xx xx xx xx xx xx xx",
    ],
  },
  {
    songName: "lo-fi 2",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Lo-fi",
    bpm: "60",
    song: [
      "Gun dos Gun dos Pa dos gos dos gos dos gos dos Pa dos gos dos",
      "Gun dos gos dos Pa dos gos dos gos dos gos dos Pa dos gos Dun",
      "Gun dos Gun dos Pa dos gos dos gos dos gos dos Pa dos gos Dun",
      "Gun dos gos dos Pa dos gos dos gos Dun gos dos gos Dun gos dos",
    ],
  },
  {
    songName: "lo-fi 1",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: [
      "Gun dos gos Gun Pa dos gos dos gos dos gos dos Pa dos gos dos",
      "Gun dos gos Gun Pa dos gos dos gos Dun Gun dos Pa dos gos dos",
    ],
  },

  {
    songName: "crbn",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos Pa Ta gos Ta Pa dos Gun dos Pa Ta gos Ta Pa dos"],
  },
  {
    songName: "Mozambique",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos dos Pa Ta gos Dun gos Ta gos Ta gos Ta Pa Ta"],
  },

  {
    songName: "113",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos Gun Dun Pa dos Gun Dun Gun dos Gun dos Pa dos gos dos"],
  },

  {
    songName: "112",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos dos gos dos gos dos Gun dos gos Dun gos Dun Gun Dun"],
  },
  {
    songName: "111",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos dos Gun dos Gun dos gos dos Gun dos Gun dos gos dos"],
  },

  {
    songName: "110",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun dos gos dos Pa dos gos Dun gos Dun Gun dos gos dos gos dos",
      "Gun dos gos dos Pa dos gos Dun gos dos gos dos gos dos gos dos",
    ],
  },
  {
    songName: "109 fill",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "2/4",
    feel: "",
    bpm: "90",
    song: ["go Ta Pa Dun gos dos Gun Ta"],
  },
  {
    songName: "109",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "2/4",
    feel: "",
    bpm: "90",
    song: ["go Ta Pa Ta gos Dun gos dos"],
  },
  {
    songName: "108",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "3/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Dun gos dos Gun dos Gun dos gos dos"],
  },

  {
    songName: "107",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "135",
    song: ["Pa Ta Gun dos Pa Ta Pa dos Pa dos Gun Ta Pa Ta Pa dos"],
  },

  {
    songName: "Minestrone 10",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Dun gos Dun Gun Ta Pa dos gos dos gos dos gos dos"],
  },

  {
    songName: "106",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun Dun gos Dun Gun Dun gos Dun Pa dos Pa Ta gos Ta Pa Ta",
      "Gun Dun gos Dun Gun Dun gos Dun gos dos gos dos gos dos gos dos",
    ],
  },
  {
    songName: "105",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun Ta Pa Dun gos Dun Gun dos Pa dos gos Dun gos Dun Gun Ta",
      "Gun Ta Pa Dun gos Dun Gun dos Pa dos gos dos gos dos gos dos",
    ],
  },
  {
    songName: "104",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun Dun gos Dun gos Dun Gun Dun gos Dun Pa Dun Gun Ta Gun Ta"],
  },
  {
    songName: "103",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "2/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun Dun gos Dun Gun Ta Pa Ta",
      "Gun Dun gos Dun Gun Ta Pa Ta",
      "Gun Dun gos Dun Gun Ta Pa Ta",
      "Gun gos Gun Ta gos Ta Pa Ta",
    ],
  },
  {
    songName: "102",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun Dun gos dos gos Dun Gun Dun Pa Dun gos Dun gos Dun Pa Ta",
      "Gun Dun gos dos gos Dun Gun Dun gos dos gos dos gos dos gos dos",
    ],
  },
  {
    songName: "101",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun dos gos Dun gos dos Gun Dun Pa dos gos Dun gos dos Gun Ta",
      "Gun dos gos Dun gos dos Gun Dun Pa dos gos dos gos dos gos dos",
    ],
  },
  {
    songName: "100",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos dos Pa dos Pa Dun gos Dun Gun dos Pa dos gos dos"],
  },
  {
    songName: "99",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Dun gos Dun Gun Dun gos Dun Gun Dun Gun Dun Pa Ta"],
  },
  {
    songName: "98",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "2/4",
    feel: "",
    bpm: "90",
    song: [
      "Pa Ta gos Dun gos dos gos dos",
      "Pa Ta gos Dun gos dos gos dos",
      "Pa Ta gos Dun gos Dun Gun dos",
      "Pa dos Pa Dun gos Ta gos Ta",
    ],
  },
  {
    songName: "97",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Dun Pa dos Pa Dun gos dos Gun dos gos dos gos dos"],
  },
  {
    songName: "96",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Ta Pa dos gos Dun gos dos gos Ta gos Ta Pa Ta"],
  },
  {
    songName: "95",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun Dun gos Ta gos Ta Pa Ta Gun Dun gos Ta gos Ta Pa dos",
      "Gun Dun gos Ta gos Ta Pa Ta Pa dos Gun dos Pa Ta Pa dos",
    ],
  },
  {
    songName: "94",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos dos Gun dos gos dos Pa Ta gos Ta gos Ta gos Ta"],
  },
  {
    songName: "93",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun dos gos dos Gun dos gos dos Gun dos gos Dun gos Ta Pa Ta",
      "Gun dos gos dos Gun dos gos dos Gun dos gos Dun gos Ta gos Ta",
      "Gun dos gos dos Gun dos gos dos Gun dos gos Dun gos Ta Pa Ta",
      "Gun dos gos dos Gun dos gos dos Gun dos gos Dun gos dos gos dos",
    ],
  },
  {
    songName: "92",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos gos Ta Pa Ta Pa Dun gos dos gos dos gos dos gos dos"],
  },
  {
    songName: "91",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: [
      "Gun dos Gun dos gos dos gos Ta gos Ta gos dos gos dos gos dos",
      "Gun dos Gun dos gos dos gos Ta gos Ta gos dos Pa Ta gos dos",
      "Gun dos Gun dos gos dos gos Ta gos Ta Pa dos Pa Ta gos Ta",
      "Gun dos Gun dos gos dos gos Ta gos Ta Pa dos Pa dos gos dos",
    ],
  },
  {
    songName: "90",
    src: "https://www.youtube.com/watch?v=aIzckuLjwik",
    timeSignature: "4/4",
    feel: "",
    bpm: "90",
    song: ["Gun dos Pa dos Gun Dun gos Dun Gun dos Pa dos Gun Dun gos Dun"],
  },
  {
    songName: "89",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "3/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos Pa Ta gos dos Pa Ta Gun dos gos dos"],
  },
  {
    songName: "88",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: [
      "Gun dos gos Dun gos Dun gos Dun Gun dos gos Dun gos Dun gos Dun",
      "Gun dos gos Dun gos Dun gos Dun Gun dos gos dos Pa dos Pa dos",
    ],
  },
  {
    songName: "87",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos gos Dun gos Dun Gun Ta Pa dos Gun dos gos dos Ta Pa"],
  },

  {
    songName: "86",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: [
      "Gun dos gos Dun gos dos gos dos Gun dos gos Dun gos dos gos Ta",
      "Gun dos gos Dun gos Ta gos Ta Gun Ta gos Dun gos Ta Pa Ta",
    ],
  },
  {
    songName: "85",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos Gun dos Gun dos gos Dun gos Dun Gun Ta Gun Ta Pa Ta"],
  },
  {
    songName: "84",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos gos Dun gos dos gos dos Gun dos gos Dun gos Dun gos Dun"],
  },
  {
    songName: "83",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun Ta Pa Dun Gun Ta Gun Ta gos dos gos dos gos dos gos dos"],
  },
  {
    songName: "82",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun Ta Pa Dun Gun Ta Gun Ta gos Ta gos Ta gos Ta Pa Ta"],
  },
  {
    songName: "81",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos gos dos Gun dos gos dos Gun dos gos Dun gos Ta Pa Ta"],
  },
  {
    songName: "80",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun Ta gos Dun gos Dun Gun Ta Gun dos gos dos gos dos gos dos"],
  },
  {
    songName: "79",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos gos Ta dos Ta Gun dos Pa dos Gun dos Pa dos gos dos"],
  },
  {
    songName: "78",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "",
    bpm: "60",
    song: ["Gun dos Gun dos Pa Ta gos Ta gos Ta gos Ta Gun Dun Gun Ta"],
  },
  {
    songName: "Orange County",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "jazz",
    bpm: "60",
    song: ["Gun dos gos Ta Gun dos gos Dun gos Dun Gun Ta Gun dos Gun dos"],
  },
  {
    songName: "Afternoon stroll",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "jazz",
    bpm: "60",
    song: ["Gun dos gos Ta Gun dos gos Ta Gun dos gos Ta gos Ta Pa Dun"],
  },
  {
    songName: "Say hi",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "pop",
    bpm: "60",
    song: ["Gun dos Gun dos gos Ta gos Ta Gun dos gos Pa gos Pa Gun Dun"],
  },
  {
    songName: "Minestrone 9",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "pop",
    bpm: "60",
    song: ["Gun dos gos Dun gos dos gos dos Gun dos gos dos gos dos gos dos"],
  },
  {
    songName: "Minestrone 8",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "pop",
    bpm: "120",
    song: ["Gun dos gos Dun gos Ta Pa Ta Gun dos gos dos gos dos gos dos"],
  },
  {
    songName: "Grandma's clothes",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "pop",
    bpm: "120",
    song: ["Gun Ta Gun dos gos dos gos Ta gos Ta Gun dos Gun Ta Gun dos"],
  },
  {
    songName: "Shake the floor",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "pop",
    bpm: "120",
    song: ["Gun dos Pa dos Pa dos Gun Ta gos Ta Gun dos Pa Gun Pa Ta"],
  },
  {
    songName: "Another fill",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "tribal",
    bpm: "120",
    song: ["Gun dos Pa Ta gos Ta dos Ta Gun dos Pa Ta Pa Ta Pa Ta"],
  },
  {
    songName: "01 am",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "tribal",
    bpm: "120",
    song: [
      "Gun dos gos Dun gos dos Gun dos gos dos gos dos gos dos gos dos",
      "Gun dos gos Dun gos dos Gun dos gos dos Gun dos Gun Dun gos Dun",
    ],
  },
  {
    songName: "Dum dum dim dum",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "tribal",
    bpm: "90",
    song: ["Gun dos Pa Dun gos Dun Gun dos Pa Dun gos Dun Gun dos Pa dos"],
  },

  {
    songName: "Blues Shuffle",
    src: "https://www.youtube.com/watch?v=ldD1LeIx4hU",
    timeSignature: "3/4",
    feel: "Blues",
    bpm: "90",
    song: ["Gun dos Gun Ta gos dos Gun dos gos Ta gos dos"],
  },

  {
    songName: "R&B Groove",
    src: "https://www.youtube.com/watch?v=BlBeHS0kj9I",
    timeSignature: "4/4",
    feel: "Pop/rock",
    bpm: "90",
    song: [
      "Gun dos gos Dun gos dos gos dos Pa dos gos dos gos dos gos dos",
      "Gun dos gos Dun gos Dun Gun dos Pa dos gos Dun gos dos gos dos",
    ],
  },
  {
    songName: "Minestrone 7",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: ["Gun dos Pa Ta gos Ta Pa Ta Gun dos gos dos gos dos gos dos"],
  },
  {
    songName: "Minestrone 7 fill",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: ["Gun dos Pa Ta gos Ta Pa Ta Gun dos Pa Ta gos Ta Pa Ta"],
  },
  {
    songName: "Minestrone 6",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: [
      "Gun dos gos Ta Gun Ta gos Dun gos dos gos dos gos dos gos dos",
      "Gun dos gos Ta Gun Ta gos Dun gos Dun gos dos Gun dos gos dos",
      "Gun dos gos Ta Gun Ta gos Dun gos dos Pa Dun gos dos gos Dun",
      "Gun dos gos Ta Gun Ta gos Dun Gun Ta Pa dos Pa dos Pa dos",
    ],
  },

  {
    songName: "3:00pm",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: [
      "Gun dos gos Dun gos dos Pa dos Gun dos gos Dun gos dos Pa dos",
      "Gun dos gos Dun gos dos Pa dos Pa dos gos Ta gos dos Pa Ta",
    ],
  },

  {
    songName: "Thunder",
    src: "https://www.youtube.com/watch?v=fKopy74weus",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: ["Gun xx gos Dun Ca xx Gun xx xx dos Gun xx Ca xx xx xx"],
  },

  {
    songName: "Thunder variant",
    src: "https://www.youtube.com/watch?v=Kb1S4w7DKeY",
    timeSignature: "4/4",
    feel: "Pop/rock",
    song: ["Gun dos gos Dun Pa dos Gun dos gos Dun Gun dos Pa dos gos dos"],
  },

  {
    songName: "Minestrone quattro",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "funk",
    song: ["Gun dos gos Dun Pa Dun gos dos gos dos gos dos gos dos gos dos"],
  },

  {
    songName: "Minestrone quattro break",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    feel: "funk",
    song: ["Gun dos gos Dun Pa Dun gos Ta gos Ta Gun Dun Pa Dun Pa Ta"],
  },

  {
    songName: "Minestrone tre",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    style: "Modern",
    tempo: "40",
    song: ["Pa dos gos Ta dos Ta Gun dos gos dos gos dos gos dos gos dos"],
  },

  {
    songName: "Sweet potato",
    src: "",
    timeSignature: "4/4",
    style: "Modern",
    tempo: "40",
    song: ["Gun dos gos Dun Pa Dun Gun Ta Gun dos Gun Dun gos Dun Gun Ta"],
  },
  // {
  //   songName: "Khaligi",
  //   src: "https://youtu.be/JZsY_R9ee6U?t=131",
  //   timeSignature: "3/4",
  //   style: "Middle eastern",
  //   tempo: "40",
  //   song: [
  //     "Gun dos Gun dos Pa dos",
  //     "Gun dos Gun dos Pa dos",
  //   ]
  //   ,
  // },

  {
    songName: "Rock groove 5",
    src: "https://youtu.be/eJ09XJ14BM4?t=290",
    timeSignature: "4/4",
    style: "Rock",
    tempo: "40",
    song: ["Gun dos gos dos Pa Dun Gun Dun Gun dos Gun dos Pa Dun gos dos"],
  },
  {
    songName: "Rock groove 4",
    src: "https://youtu.be/eJ09XJ14BM4?t=262",
    timeSignature: "4/4",
    style: "Rock",
    tempo: "40",
    song: ["Gun dos gos Dun Pa dos Gun dos Gun dos Gun Dun Pa dos gos dos"],
  },
  {
    songName: "Rock groove 3",
    src: "https://youtu.be/eJ09XJ14BM4?t=155",
    timeSignature: "4/4",
    style: "Rock",
    tempo: "40",
    song: ["Gun Dun gos dos Pa dos gos dos gos dos gos dos Pa dos Gun Ta"],
  },
  {
    songName: "Rock groove 2",
    src: "https://youtu.be/eJ09XJ14BM4?t=137",
    timeSignature: "4/4",
    style: "Rock",
    tempo: "40",
    song: ["Gun dos gos dos Pa dos gos Dun gos dos Gun dos Pa dos gos Dun"],
  },
  {
    songName: "Rock groove alpha",
    src: "Marco://youtu.be/eJ09XJ14BM4?t=137",
    timeSignature: "4/4",
    style: "Rock",
    tempo: "40",
    song: ["Gun dos gos dos Pa dos gos dos gos dos Gun dos Pa dos gos dos"],
  },

  {
    songName: "Amen break",
    src: "https://youtu.be/VtJCTLwcw6s?t=126",
    timeSignature: "4/4",
    style: "Rock",
    song: ["Gun dos Gun dos Pa dos gos Ta dos Ta Gun Dun Pa dos gos dos"],
  },

  {
    songName: "Amen break variant",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    style: "Rock",
    song: ["Gun dos Gun dos Pa Ta gos Ta dos Ta Gun Ta Pa dos gos dos"],
  },

  {
    songName: "Beat it",
    src: "https://www.youtube.com/watch?v=NaOPNwjhURQ",
    timeSignature: "4/4",
    style: "",
    song: ["Gun dos Pa dos Gun dos Pa dos Gun dos Pa dos gos Dun Pa dos"],
  },
  {
    songName: "Fill 7",
    src: "https://youtu.be/ByERSyW828Y?t=285",
    timeSignature: "4/4",
    style: "",
    song: ["Pa Ta Pa Ta Gun Dun Gun Dun Pa Ta xx xx Pa Ta Pa Ta"],
  },
  {
    songName: "Fill 6",
    src: "https://youtu.be/ByERSyW828Y?t=242",
    timeSignature: "4/4",
    style: "",
    song: ["Pa Gun Dun Ta Gun dos Pa Dun Gun Ta Gun dos Pa Ta Pa Ta"],
  },

  {
    songName: "Fill 5",
    src: "https://youtu.be/ByERSyW828Y?t=187",
    timeSignature: "4/4",
    style: "",
    song: ["Gun dos Gun Pa Gun dos Gun Pa Gun dos Gun Pa Gun Dun Gun Dun"],
  },

  {
    songName: "Fill 4",
    src: "https://youtu.be/ByERSyW828Y?t=135",
    timeSignature: "4/4",
    style: "",
    song: ["Gun dos Gun dos Gun dos gos Ta Pa dos gos Ta Pa dos Pa dos"],
  },

  {
    songName: "Lut gaye",
    src: "https://youtu.be/aC51OjA992I",
    timeSignature: "4/4",
    style: "indian",
    song: ["Gun xx xx do go xx go xx xx do xx do Gun xx xx xx"],
  },

  {
    songName: "You and me",
    src: "Pizeta --> https://open.spotify.com/track/3bUknCt3Ga7f1zH1ElCSJu?si=pan7-YJKTSi3Up7f9ttSKg",
    timeSignature: "4/4",
    song: ["Gun xx xx Ta Pa xx xx xx Gun do xx do Pa xx go Dun"],
  },
  {
    songName: "You and me variant",
    src: "Pizeta --> https://open.spotify.com/track/3bUknCt3Ga7f1zH1ElCSJu?si=pan7-YJKTSi3Up7f9ttSKg",
    timeSignature: "4/4",
    song: ["Gun xx xx Dun Pa xx xx xx Gun do xx do Pa do go Ta"],
  },
  {
    songName: "A-Velocity",
    src: "",
    timeSignature: "4/4",
    song: ["Gun xx Gun xx Pa Ta xx xx Gun xx xx Ca xx xx xx xx"],
  },
  {
    songName: "A-Velocity variant 1",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos Gun dos Pa Ta gos dos Gun dos gos Ca gos dos gos dos"],
  },
  {
    songName: "A-Velocity variant 2",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos Ta Pa Ta gos dos Gun dos gos Pa gos dos gos dos"],
  },
  {
    songName: "A-Velocity variant 3",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos dos Pa Ta gos dos Gun dos gos Pa gos dos gos dos"],
  },

  {
    songName: "Cissy strut",
    src: "https://youtu.be/Prg73ySVu6E?t=291",
    timeSignature: "4/4",
    feel: "swing",
    song: ["Gun dos gos Dun Pa Dun gos dos Gun dos gos Dun Pa Dun Pa dos"],
  },

  {
    songName: "Cissy fill",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos Dun gos dos Gun dos gos dos Gun dos Gun dos gos dos"],
  },

  {
    songName: "Ain't nobody",
    src: "https://youtu.be/Prg73ySVu6E?t=185",
    timeSignature: "4/4",
    song: ["Gun Dun gos dos Pa dos gos Dun gos dos gos Dun Pa Dun gos dos"],
  },

  {
    songName: "28",
    src: "https://cajonmaster.com/groove-course-1/",
    timeSignature: "4/4",
    song: ["Gun dos gos Dun Pa Ta gos Ta gos Ta Gun Ta Pa Dun gos dos"],
  },
  {
    songName: "27",
    src: "https://cajonmaster.com/groove-course-1/",
    timeSignature: "4/4",
    song: ["Gun dos gos dos Pa Ta dos Ta gos Ta gos Ta Pa dos gos dos"],
  },
  {
    songName: "R2D2",
    src: "https://cajonmaster.com/groove-course-1/",
    timeSignature: "4/4",
    song: ["Gun Ta gos dos Pa dos gos dos Gun Ta gos dos Pa dos gos dos"],
  },

  {
    songName: "Goldskin",
    src: "https://youtu.be/04IXXJxNwtk?t=32",
    timeSignature: "4/4",
    song: ["Gun dos gos dos Pa dos gos dos Gun dos gos dos Pa dos gos dos"],
  },
  {
    songName: "Minestrone due",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos Dun gos dos Gun dos gos dos gos dos gos dos gos dos"],
  },

  {
    songName: "Fill 1",
    src: "https://www.youtube.com/watch?v=rhPL28kKS2Q",
    timeSignature: "4/4",
    song: ["Pa dos gos Ta gos dos Pa dos gos Ta gos dos Pa dos Pa Ta"],
  },

  {
    songName: "Fill 2",
    src: "https://www.youtube.com/watch?v=rhPL28kKS2Q",
    timeSignature: "4/4",
    song: ["Pa dos gos Ta gos dos Pa dos gos dos Pa dos Pa Ta Pa Ta"],
  },
  {
    songName: "Fill 3",
    src: "https://www.youtube.com/watch?v=rhPL28kKS2Q",
    timeSignature: "4/4",
    song: ["Gun dos gos Ta Pa dos Pa dos gos Ta Pa dos Pa dos Pa Ta"],
  },
  {
    songName: "Minestrone uno",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos dos gos dos gos dos gos dos gos dos gos Ta go do"],
  },
  {
    songName: "Minestrone uno Fill",
    src: "",
    timeSignature: "4/4",
    song: ["Gun do go do Gun do go do Gun Ta Gun Ta Gun Ta go do"],
  },
  {
    songName: "Lato",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    song: ["Pa dos Pa dos gos dos gos Ta gos Ta Pa dos gos dos gos dos"],
  },
  {
    songName: "Otal",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    song: ["Gun dos Gun dos gos dos gos Dun gos Dun Gun dos gos dos gos dos"],
  },
  {
    songName: "Mix A",
    src: "https://youtu.be/5HIAuK9RS6E?list=PL68l7-3lyYtPdVsAAru0cJQfYx9wHu5tB&t=218",
    timeSignature: "4/4",
    song: ["Gun xx Gun xx go do xx Ta xx do xx go do Ta Pa Ta"],
  },

  {
    songName: "Mix A variant",
    src: "https://youtu.be/5HIAuK9RS6E?list=PL68l7-3lyYtPdVsAAru0cJQfYx9wHu5tB&t=218",
    timeSignature: "4/4",
    song: ["Gun dos Gun dos gos dos gos Pa gos dos gos gos dos Ta Pa Ta"],
  },

  {
    songName: "OG 4/4",
    src: "",
    timeSignature: "4/4",
    song: ["Gun dos gos dos Ca xx dos Gun xx Gun xx dos Ca xx xx xx"],
  },

  {
    songName: "Baba ganoush",
    src: "https://youtu.be/WR_du_EPITw?list=PL68l7-3lyYtPdVsAAru0cJQfYx9wHu5tB",
    timeSignature: "4/4",
    song: ["Gun dos gos Ta gos dos Gun dos gos Ta gos dos Gun gos dos gos"],
  },

  {
    songName: "Workout 7/4",
    src: "https://www.youtube.com/watch?v=YFNegZdsDpE",
    timeSignature: "7/4",
    song: ["Gun xx gos dos gos dos Gun xx xx Dun xx Pa xx xx"],
  },

  {
    songName: "Chaabi",
    src: "https://www.youtube.com/watch?v=xM83XVw83yk",
    timeSignature: "3/4",
    song: ["xx xx Pa xx Gun xx xx Ta xx xx Gun xx"],
  },

  {
    songName: "Chaabi variant",
    src: "https://www.youtube.com/watch?v=xM83XVw83yk",
    timeSignature: "3/4",
    song: ["xx xx Pa dos Gun xx xx Ta xx dos Gun xx"],
  },

  {
    songName: "Kono",
    src: "https://www.youtube.com/watch?v=5HIAuK9RS6E&t=8s",
    timeSignature: "4/4",
    song: ["Gun do go do Gun xx Ta Pa Gun do go do Gun xx Pa xx"],
  },
  {
    songName: "Kono variant",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "4/4",
    song: ["Gun dos gos dos Gun xx Ta Pa Gun dos gos dos Gun xx Pa xx"],
  },
  {
    songName: "Yankadi",
    src: "https://www.youtube.com/watch?v=5HIAuK9RS6E&t=8s",
    timeSignature: "4/4",
    song: ["Gun xx go do Gun Ta Pa xx Gun xx go xx Gun Ta Pa xx"],
  },
  {
    songName: "Yankadi variant",
    src: "https://www.youtube.com/watch?v=5HIAuK9RS6E&t=8s",
    timeSignature: "4/4",
    song: ["Gun xx gos dos Gun Ta Pa xx Gun xx gos xx Gun Ta Pa xx"],
  },
  {
    songName: "Kuku",
    src: "https://www.youtube.com/watch?v=5HIAuK9RS6E&t=8s",
    timeSignature: "4/4",
    song: ["Gun Dun go do Gun Dun Ca xx Gun Dun go do Gun Gun Ca xx"],
  },
  {
    songName: "3/4 hello world",
    src: "",
    author: "Marco Baldessari",
    timeSignature: "3/4",
    song: ["Gun do go do Gun xx Gun do go do Gun Ta"],
  },
  {
    songName: "Didadi",
    src: "https://www.youtube.com/watch?v=5HIAuK9RS6E&t=8s",
    timeSignature: "4/4",
    song: ["Gun xx Pa Dun xx Ta Gun xx Gun xx xx Ta Pa xx go do"],
  },
  {
    songName: "Bala Kulandyan",
    timeSignature: "4/4",
    song: ["Pa xx xx Ta Pa xx go do Pa xx xx Ta Pa xx go do"],
  },

  {
    songName: "Djansa",
    timeSignature: "4/4",
    song: ["Pa Ta xx Ta Pa xx do go Ta xx Gun xx Ta Dun go do"],
  },
  {
    songName: "Djansa variant",
    timeSignature: "4/4",
    song: ["Pa Ta xx Ta Pa xx dos gos Ta xx Gun xx Ta Dun gos dos"],
  },
];
